export enum RequestStatus {
  Idle = 'idle',
  Loading = 'loading',
  Success = 'success',
  Error = 'error',
}

export type MoneyServerType = {
  amount: string
  currency: string
}

export type MoneyType = {
  amount: number
  currency: string
}

export type Trend = 'positive' | 'negative' | 'neutral'

export type ErrorHandlingOptions = {
  title?: string
  message?: string
  showRetryButton?: boolean
  showHomeButton?: boolean
  error?: Error
  redirectToErrorPage?: boolean
}
